import useLogicalProducts from "../../../hooks/useLogicalProducts";
import { getImageUrl } from "../../../utils";
import { placeholderImaage } from "../../../utils/constants";
import { Widget } from "../../../widgetList/widgetList";
import PopulerProduct from "../../Widgets/PopulerProduct";
import ProductCard from "../ProductCard";
import classes from "./PopularProducts.module.css";

interface Props {
	dir?: "left" | "right";
	widget?: Widget;
}

const PopularProducts = ({
	dir: _dir = "left",

	widget,
}: Props) => {
	const { products, loading, error } = useLogicalProducts({
		widget,
	});

	const settings = widget?.data?.settings || {};
	const dir = widget?.fetcturedImagePosition || "left";

	if (loading || !products) return <PopulerProduct />;

	return (
		<section className={`${classes.PopularProducts}`}>
			<div className="container">
				<div className={[classes.contents, classes[dir]].join(" ")}>
					<div className={classes.left}>
						<div className={classes.banner}>
							<img
								src={
									getImageUrl(widget?.featuredImage || "") ||
									placeholderImaage
								}
								alt="banner"
								style={{
									aspectRatio: 310 / 790,
									objectFit: "cover",
								}}
							/>
						</div>
					</div>

					<div className={classes.right}>
						<div className={classes.products}>
							{products?.slice(0, 8).map((product, i) => (
								<ProductCard
									key={i}
									productItem={product}
									settings={settings}
								/>
							))}
						</div>
					</div>
				</div>
			</div>

			{/* {(loading || !isIntersecting) ? (
                <div className="container py-4">
                    <ProductsSectionSkleton />
                </div>
            ) : (
            )} */}
		</section>
	);
};

export default PopularProducts;
